// Image Cropper Component Types

export enum AspectRatioValues {
  ONE_TO_ONE = '1:1',
  FOUR_TO_THREE = '4:3',
  SIXTEEN_TO_NINE = '16:9',
  COVER = '5:2', // Updated for larger cover images (wider but with more height than 4:1)
  FREE = 'free',
}

export interface ImageCropperProps {
  imageSrc: string
  onCancel: () => void
  onApply: (editedImage: Blob) => void
  defaultAspectRatio?: AspectRatioValues
  aspectRatios?: { label: string; value: AspectRatioValues }[]
}

export interface AspectRatio {
  label: string
  value: AspectRatioValues
  ratio?: number
}

export interface CropArea {
  x: number
  y: number
  width: number
  height: number
}

export interface ImageTransform {
  crop: CropArea
  rotation: number
  flipHorizontal: boolean
  flipVertical: boolean
  aspectRatio: AspectRatioValues
  zoom: number
}

export interface ImageEditorProps {
  imageSrc: string
}

export interface CropToolbarProps {
  onRotateLeft: () => void
  onRotateRight: () => void
  onFlipHorizontal: () => void
  onFlipVertical: () => void
}

export interface AspectRatioSelectorProps {
  value: AspectRatioValues
  onChange: (value: AspectRatioValues) => void
  options: AspectRatio[]
}
